export default {
	namespaced: true,
	state: {
        pageSize: 10,
		activatedTest: false,
        correctlyAnswered: [
            'Это верный ответ!',
            'Правильно!',
            'Отлично! Продолжайте!',
            'Превосходно!',
            'Замечательно!',
            'Это фантастика! Великолепный результат!',
            'Искусственный интеллект аплодирует вам!',
            'Впечатляет!!!',
            'Отлично! Не все знают ответ на этот вопрос!',
            'Вы на пути к триумфу!'
        ],
        wrongAnswer: [
            'К сожалению, это неверно.',
            'Жаль! Вы были близки к правильному ответу.',
            'Неправильно. Придется повторить материал.',
            'А вы точно это учили?',
            'Соберитесь! Вы теряете баллы!',
            'Может, со следующим вопросом получится лучше?',
            'А вот и нет!',
            'Неверно! Надо бы повторить эту тему.',
            'Каждая ваша ошибка причиняет мне боль. Не делайте так!',
            'Ошибаться - это нормально, но впредь будьте внимательнее.'
        ],
        '0_39': [
            'Ужасно! Рекомендуем повторить материал.',
            'А вы точно хотите стать врачом? ',
            'Похоже, вы решили проверить свою интуицию...  В следующий раз опирайтесь на свои знания!',
            'ОК, вы показали, как можно провалить тест. А теперь покажите, как сдать его успешно!',
            'Результат оставляет желать лучшего. Соберитесь уже!',
            'Будь я пациентом, то не подошел бы к вам и на пушечный выстрел.',
            'Кот по клавиатуре прошел?',
            'Поздравляю! Вы мастерски провалили тест!',
            'Ничего страшного, есть много других хороших профессий.',
            'Похоже, кое-кто не выучил материал.',
            'Мне больно смотреть на этот результат!'
        ],
        '40_69': [
            'Вы на верном пути! Попробуйте еще раз',
            'Ой, нет! Я поищу другого доктора! А вы пока повторите материал.',
            'Согласитесь, что вам стоит повторить материал.',
            'Неплохо! Но я бы не рискнул лечиться у вас.',
            'И это все, на что вы способны?! Повторите материал и попробуйте еще раз!',
            'Не ожидали? Я тоже. Ведь вы можете лучше.',
            'Сомнительный результат! Хотя бывает и хуже.',
            'В следующий раз будьте внимательнее!',
            'Средненько... Можно и лучше!',
            '"Повторение - мать учения". Намек понятен?'
        ],
        '70_90': [
            'Почти все правильно!',
            'Спасибо, доктор! Вы меня почти вылечили!',
            'Молодец! В следующий раз вы должны набрать 100 баллов!',
            'Довольно неплохо! А тем временем кто-то набирает 100 баллов. И вы сможете!',
            'Очень хорошо, но вы способны на большее!',
            'Очень даже неплохо! Вы рады? А представляете, если бы вы набрали 100 баллов!',
            'Я бы вас поздравил, но знаю, что вы ожидали большего. Поэтому предлагаю попробовать еще раз.',
            'Хорошо. Но есть куда стремиться!',
            'Когда-нибудь вы сдадите этот тест на 100 баллов!',
            'Вы близки к успеху!',
            'Ваш результат радует!'
        ],
        '91_100': [
            'К такому доктору я бы пошел!',
            'Браво! Это отличный результат!',
            'А вы даже дучше, чем я думал!',
            'Так держать, отличник!',
            'Прекрасно! Я обязательно посоветую вас своим друзьям как хорошего доктора!',
            'Невероятно!!! Пожалуй, я запомню вас. Пригодится!',
            'Вы на пути к тому, чтобы стать прекрасным специалистом!',
            'Можете гордиться своими знаниями!',
            'Великолепно! Не все так могут!',
            'Сильно!',
            'Вау!',
            'У вас острый ум!',
            'Хорошая работа!',
            'Обалденно!',
            'Изумительно!',
            'Ух ты!',
            'Высший класс!',
            'Великолепно!',
            'Вообще супер!',
            'Фантастика!',
            'Клёво!',
            'Лучше не бывает!',
            'Это просто нечто!',
            'Мощно!',
            'Хорошо!',
            'Супер!',
            'Суперски!',
            'Прекрасно!',
            'Мастерски!',
            'Вы постарались!'
        ]
	},
	getters: {
		getActivatedTest: state => state.activatedTest,
        getPageSize: state => state.pageSize
	},
	mutations: {
		changeActivatedTest(state, val) {
			state.activatedTest = val
		}
	},
    actions: {
        randomGenerate({ state }, name) {
            let index = Math.floor(Math.random() * state[name].length);
            return state[name][index]
        },
        changePageSize({ state }, name) {
           state.pageSize = name
        }
    }
};

export const helpers = {
    testTypes: ['Обучение', 'Диагностика'],
    createStatuses: { InProgress: 'InProgress', Done: 'Done', Published: 'Published' },
    getScoreColor(score) {
        if (score < 25) {
            return '#EE4040';
        }

        if (score < 50) {
            return '#EEC840';
        }

        if (score < 75) {
            return '#21B8DA';
        }

        return '#33A56E';
    },


 };
